import { Container } from '@mui/material';
import React, { useState } from 'react'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Auth from '../auth/Auth';
import Register from '../auth/Register';
import CreateTopics from './CreateTopics';
import ReadTopics from './ReadTopics';
import CountrendingDisplay from './CountrendingDisplay';

const TopicsHome = () => {
    const [key, setKey] = useState('login');
    
    return (
        <>
         <Container className='mt-4' style={{width:"50%"}}>
       
            <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
                style={{textAlign:"center",alignItems:"center"}}
            >
                <Tab eventKey="login" title="Login">
                 <Auth setKey={setKey}/>
                </Tab>
                <Tab eventKey="createTopic" title="CreateTopics">
                   <CreateTopics/>
                </Tab>
                <Tab eventKey="topics" title="ReadTopics">
                   <ReadTopics/>
                </Tab>
                <Tab eventKey="tranding" title="Treanding Count">
                   <CountrendingDisplay/>
                </Tab>
               
            </Tabs>
            </Container>


           
        </>
    )
}

export default TopicsHome